module.exports = {"origin":"https://yufa-authapi.51tuoguanyun.com","page":"https://yufa-portal.51tuoguanyun.com"}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/uat.json
 ** module id = 758
 ** module chunks = 1
 **/